<div class="lista-chat">
  <header class="lista-chat-topo">
    <div class="lista-chat-marca">
      <button type="button" class="lista-chat-btn-menu" (click)="abrirMenu.emit()" aria-label="Abrir menu">
        <img src="./assets/icones/redesign/header/header-menu-open.svg" alt="" />
      </button>
      <img src="./assets/clari-talk-logo.png" alt="ClariTalk" class="lista-chat-logo" />
      <button type="button" class="lista-chat-btn-adicionar" matTooltip="Criar novo contato" aria-label="Criar novo contato"
              (click)="criarContato.emit()">
        <span class="lista-chat-btn-adicionar-icone" aria-hidden="true"></span>
      </button>
    </div>

    <div class="lista-chat-barra">
      <div class="lista-chat-abas" [class.lista-chat-abas-compactas]="buscaAberta()">
        @for (item of abas; track item.valor) {
          <button
            type="button"
            class="lista-chat-aba"
            [class.lista-chat-aba-ativa]="item.valor === aba()"
            [class.lista-chat-aba-favoritos]="item.valor === 'FAVORITOS'"
            [attr.aria-label]="item.label"
            [matTooltip]="item.label"
            (click)="selecionarAba(item.valor)"
          >
            <img [src]="item.valor === aba() ? item.iconeAtivo : item.iconeInativo" alt="" class="lista-chat-aba-icone" />
            @if (carregando() && contatos().length === 0) {
              <span class="lista-chat-aba-contador lista-chat-aba-contador-skeleton skeleton"></span>
            } @else {
              <span class="lista-chat-aba-contador" [attr.title]="contadorAba(item.valor)">{{ contadorAbaAbreviado(item.valor) }}</span>
            }
          </button>
        }
      </div>

      <div class="lista-chat-acoes">
        <div class="lista-chat-busca" [class.lista-chat-busca-aberta]="buscaAberta()"
            role="button" tabindex="0" (click)="abrirBusca()" (keydown.enter)="abrirBusca()">
          <img src="./assets/icones/redesign/inputs/icon-search-input.svg" alt="" class="lista-chat-busca-icone" />
          <input
            #campoBusca
            type="text"
            class="lista-chat-busca-input"
            placeholder="Buscar por nome ou número..."
            autocomplete="off"
            [tabindex]="buscaAberta() ? 0 : -1"
            [(ngModel)]="textoFiltro"
            (ngModelChange)="aoDigitarBusca()"
          />
          <button type="button" class="lista-chat-busca-fechar" [tabindex]="buscaAberta() ? 0 : -1"
                  (click)="fecharBusca(); $event.stopPropagation()" aria-label="Fechar busca">
            <img src="./assets/icones/redesign/inputs/container-cancel.svg" alt="" />
          </button>
        </div>

        <button type="button" class="lista-chat-btn-filtro"
                (click)="alternarFiltros()" aria-label="Filtros" [attr.aria-expanded]="filtrosAbertos()">
          <img [src]="filtrosAbertos() || temFiltroAvancado()
                  ? './assets/icones/redesign/inputs/more-filters-gray.svg'
                  : './assets/icones/redesign/inputs/more-filters-primary.svg'" alt="" />
        </button>

      </div>
    </div>
  </header>

  @if (filtrosAbertos()) {
    <section class="lista-chat-filtros" @expandir>
      <span class="lista-chat-filtros-titulo">Filtros</span>
      <app-campo-select
        label="Canais"
        placeholder="Todos"
        campo="nome"
        [multiplo]="true"
        [opcaoTodos]="true"
        [habilitarBusca]="true"
        [lista]="canais()"
        [carregando]="carregandoOpcoesFiltro()"
        [ngModel]="canaisSelecionados()"
        (selecionarItem)="selecionarCanais($event)"
      ></app-campo-select>
      @if (exibeFiltroOperador) {
        <app-campo-select
          label="Operador"
          placeholder="Todos"
          campo="nome"
          [multiplo]="true"
          [opcaoTodos]="true"
          [habilitarBusca]="true"
          [lista]="operadores()"
          [carregando]="carregandoOpcoesFiltro()"
          [ngModel]="operadoresSelecionados()"
          (selecionarItem)="selecionarOperadores($event)"
        ></app-campo-select>
      }
    </section>
  } @else if (temFiltroAvancado()) {
    <div class="lista-chat-chips" @expandir>
      @if (chipCanais(); as chip) {
        <span class="lista-chat-chip" [matTooltip]="chip.titulo" @surgir>
          <span class="lista-chat-chip-texto">{{ chip.texto }}</span>
          @if (chip.extras > 0) {
            <span class="lista-chat-chip-extras">+{{ chip.extras }}</span>
          }
          <button type="button" class="lista-chat-chip-remover" (click)="limparFiltroCanais()" aria-label="Remover filtro de canal">
            <img src="./assets/icones/redesign/inputs/container-cancel.svg" alt="" />
          </button>
        </span>
      }
      @if (chipOperadores(); as chip) {
        <span class="lista-chat-chip" [matTooltip]="chip.titulo" @surgir>
          <span class="lista-chat-chip-texto">{{ chip.texto }}</span>
          @if (chip.extras > 0) {
            <span class="lista-chat-chip-extras">+{{ chip.extras }}</span>
          }
          <button type="button" class="lista-chat-chip-remover" (click)="limparFiltroOperadores()" aria-label="Remover filtro de operador">
            <img src="./assets/icones/redesign/inputs/container-cancel.svg" alt="" />
          </button>
        </span>
      }
    </div>
  }

  @if (buscando()) {
    <div class="lista-chat-progresso"><span></span></div>
  }

  @if (carregando()) {
    <div class="lista-chat-itens" appArrastarAbas [podeAnterior]="abas[0].valor !== aba()" [podeProxima]="abas[abas.length - 1].valor !== aba()" (abaAnterior)="trocarAbaRelativa(-1)" (proximaAba)="trocarAbaRelativa(1)">
      @for (linha of linhasSkeleton; track linha) {
        <div class="contato-item contato-item-skeleton">
          <div class="contato-avatar skeleton"></div>
          <div class="contato-conteudo">
            <div class="skeleton contato-skeleton-linha" style="width: 55%"></div>
            <div class="skeleton contato-skeleton-linha" style="width: 35%"></div>
            <div class="skeleton contato-skeleton-linha" style="width: 75%"></div>
          </div>
        </div>
      }
    </div>
  } @else if (contatos().length === 0) {
    <div class="lista-chat-itens" appArrastarAbas [podeAnterior]="abas[0].valor !== aba()" [podeProxima]="abas[abas.length - 1].valor !== aba()" (abaAnterior)="trocarAbaRelativa(-1)" (proximaAba)="trocarAbaRelativa(1)">
      <div class="lista-chat-vazio">
        <img src="./assets/icones/redesign/modulos/chat/filter/filter-all-primary.svg" alt="" class="lista-chat-vazio-icone" />
        <span class="lista-chat-vazio-titulo">Nenhum contato encontrado</span>
        <span class="lista-chat-vazio-texto">{{ textoVazio }}</span>
      </div>
    </div>
  } @else {
    <cdk-virtual-scroll-viewport #areaItens appArrastarAbas [podeAnterior]="abas[0].valor !== aba()" [podeProxima]="abas[abas.length - 1].valor !== aba()" (abaAnterior)="trocarAbaRelativa(-1)" (proximaAba)="trocarAbaRelativa(1)" class="lista-chat-itens lista-chat-itens-virtual"
                                [itemSize]="alturaItem" [minBufferPx]="alturaItem * 6" [maxBufferPx]="alturaItem * 12"
                                (scroll)="onScroll()">
      <ng-container *cdkVirtualFor="let linha of linhasLista(); trackBy: rastrearLinha">
        @if (linha.contato; as contato) {
          <div
            class="contato-item"
            role="button"
            tabindex="0"
            [class.contato-item-selecionado]="contato.id === contatoSelecionadoId"
            [class.contato-item-novo]="contatosNovos().has(contato.id)"
            [class.contato-item-saindo]="contatosSaindo().has(contato.id)"
            [class.contato-item-sem-tags]="!temLinhaTags(contato)"
            (click)="selecionarContato(contato)"
            (keydown.enter)="selecionarContato(contato)"
          >
            <div class="contato-avatar-coluna">
              <div class="contato-avatar-wrapper" [matTooltip]="tooltipFotoContato(contato)">
                <img class="contato-avatar" [class.contato-avatar-foto]="possuiFotoPerfil(contato)" [src]="fotoContato(contato)" alt="" (error)="marcarFotoIndisponivel(contato)" />
                @if (logoCanalOrigem(contato); as logo) {
                  <img class="contato-avatar-canal" [src]="logo" alt=""
                      [class.contato-avatar-canal-instagram]="contato.canalOrigem === CanalOrigemContatoEnum.INSTAGRAM" />
                }
              </div>
              @if (contato.operadorAvatar; as operador) {
                <app-avatar-pessoa class="contato-avatar-operador" [pessoa]="operador" [tamanho]="20"
                    [matTooltip]="'Atendente: ' + (operador.nome ?? '')"></app-avatar-pessoa>
              }
            </div>

            <div class="contato-conteudo">
              <div class="contato-linha-topo">
                <div class="contato-nome-wrapper">
                  <span class="contato-nome">{{ contato.nome || contato.contato }}</span>
                  @if (contato.favorito) {
                    <img src="./assets/icones/redesign/modulos/chat/filter/filter-fav-golden.svg" alt="Importante" class="contato-favorito"
                        matTooltip="Importante" />
                  }
                  @if (contato.tranferenciaPendenteVisu) {
                    <img src="./assets/icones/tranferencia_atendimento_pendente_visu.svg" alt="" class="contato-icone-transferencia"
                        matTooltip="Atendimento transferido para você" />
                  }
                </div>
                <span class="contato-tempo">{{ tempoUltimaMensagem(contato.dataUltimaMensagem) }}</span>
              </div>

              @if (temLinhaTags(contato)) {
              <div class="contato-linha-tags">
                <div class="contato-tags">
                  @if (contato.canal?.nome) {
                    <span class="contato-tag" [matTooltip]="'Canal: ' + (contato.canal?.nome ?? '')">
                      <span class="contato-tag-bolinha contato-tag-bolinha-canal"></span>
                      <span class="contato-tag-texto">{{ contato.canal?.nome }}</span>
                    </span>
                  }
                  @for (tag of tagsVisiveis(contato); track $index) {
                    <span class="contato-tag" [matTooltip]="'Etiqueta: ' + tag">
                      <span class="contato-tag-bolinha contato-tag-bolinha-tag"></span>
                      <span class="contato-tag-texto">{{ tag }}</span>
                    </span>
                  }
                  @if (tagsExcedentes(contato) > 0) {
                    <span class="contato-tag contato-tag-excedente" [matTooltip]="tooltipTagsExcedentes(contato)">+{{ tagsExcedentes(contato) }}</span>
                  }
                </div>
                @if (contato.qtdMensagensNaoLidas > 0) {
                  <span class="contato-nao-lidas">{{ textoContador(contato.qtdMensagensNaoLidas) }}</span>
                }
              </div>
              }

              <app-previa-mensagem [previa]="contato.ultimaMensagemPrevia" [textoAlternativo]="contato.ultimaMensagem"></app-previa-mensagem>
            </div>
          </div>
        } @else {
          <div class="contato-item contato-item-skeleton">
            <div class="contato-avatar skeleton"></div>
            <div class="contato-conteudo">
              <div class="skeleton contato-skeleton-linha" style="width: 55%"></div>
              <div class="skeleton contato-skeleton-linha" style="width: 75%"></div>
            </div>
          </div>
        }
      </ng-container>
    </cdk-virtual-scroll-viewport>
  }

  @if (mostrarTopo()) {
    <button type="button" class="lista-chat-btn-topo" aria-label="Voltar ao topo da lista" @surgir (click)="irAoTopo()">
      <img src="./assets/icones/redesign/utils/chevron-top-primary.svg" alt="" />
    </button>
  }
</div>
